<template>
  <div>
    <el-button-group v-if="!isViewDisabled">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="add()"
        class="mb-2"
      >{{$l('form_add_btn')||'新增'}}</el-button>
    </el-button-group>
    <!-- 表格-->
    <el-table :data="tableData" stripe size="small"
              :height="height"
              style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        prop="scmFileUrl"
        :label="$l('doc_table_label_image')||'文档图片'"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <img :src="scope.row.scmThumbImageUrl?scope.row.scmThumbImageUrl:scope.row.scmFileUrl" v-if="scope.row.docType === 'image'" style="width: 100%">
          <img :src="defaultUrl" v-else style="width: 100%">
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="scmFileName"
        :label="$l('doc_table_label_name')||'文档名称'"
        min-width="200">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="scmFileType"
        :label="$l('doc_table_label_type')||'文档类型'"
        min-width="200">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="uploadTime"
        :label="$l('doc_table_label_upload_time')||'上传时间'"
        min-width="200">
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="scmStatus"
        :label="$l('doc_table_label_status')||'状态'"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.scmFileStatusText === '有效' ? 'success' : 'danger'"
          >{{scope.row.scmFileStatusText}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$l('table_label_operation')||'操作'"
        min-width="200"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit-outline"
            v-if="!isViewDisabled"
            @click="update(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            style="padding:5px;"
            v-if="scope.row.scmFileStatus == 'Y'"
            @click="dowloadDoc(scope.row)"

            icon="el-icon-download"
          ></el-button>
          <el-button
            size="mini"
            style="padding:5px;"
            type="danger"
            :disabled="scope.row.scmFileStatusText === '无效' || scope.row.docType === 'image'"
            v-if="!isViewDisabled"
            @click="del(scope.row)"
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png"/>
          <p class="no-data">{{$l('INDEX.tips_no_data') || '暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <template>
      <el-pagination
        background
        :current-page="params.curPage"
        :page-size="params.pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, sizes, prev, pager, next, jumper, ->, slot">
      </el-pagination>
    </template>
    <el-dialog
      @opened="dialogOpened"
      @closed="dialogClosed"
      title="资料信息"
      :visible.sync="dialogVisible1"
      width="800px">
      <DocDetail ref="contactsDetail" @back="back" @getData="getData"></DocDetail>
    </el-dialog>
  </div>
</template>
<script>
import DocDetail from './detail/docDetail'
import util from '@/libs/util'
export default {
  props: {
    height: {
      default: 350,
      type: Number
    }
  },
  components: {
    DocDetail
  },
  data () {
    return {
      dialogVisible1: false,
      isViewDisabled: false,
      tableData: [],
      formData: {},
      params: {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      },
      total: 0,
      thumbImageSpec: '?x-oss-process=image/resize,m_fill,h_100,w_100', // 缩略图规格为100*100
      defaultUrl: 'http://jscloud-shop.oss-cn-shanghai.aliyuncs.com/202004/9aa6076a3f214b271d2c121c07907dae.JPEG?Expires=1902464647&OSSAccessKeyId=LTAIeUAWRhBQ20Xn&Signature=xpuUijsh%2B8QkFdEtx0tV03eQa68%3D'
    }
  },
  methods: {
    init (scmCode, isViewDisabled) {
      this.params.scmCode = scmCode
      this.isViewDisabled = isViewDisabled
      this.getData()
    },
    reset () {
      this.dialogVisible1 = false
      this.isViewDisabled = false
      this.thumbImageSpec = '?x-oss-process=image/resize,m_fill,h_100,w_100' // 缩略图规格为100*100
      this.tableData = []
      this.formData = {}
      this.params = {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      }
      this.getData()
    },
    getData () {
      this.$api.scmInfoDocListApi(this.params).then(res => {
        this.total = res.body.count
        this.params.curPage = res.body.curPage
        this.params.pageSize = res.body.pageSize
        this.tableData = res.body.data
      })
    },
    dialogOpened () {
      this.$refs.contactsDetail.init(this.formData)
    },
    dialogClosed () {
      this.getData()
    },
    add () {
      this.formData = {
        type: 'add',
        scmFileUrl: '',
        scmFileStatus: 'Y',
        scmFileUrlThum: '',
        scmCode: this.params.scmCode
      }
      this.dialogVisible1 = true
    },
    update (row) {
      this.formData = row
      this.formData.type = 'update'
      this.dialogVisible1 = true
    },
    save () {
      this.dialogVisible1 = false
    },
    // 下载文件 row.scmFileUrl
    dowloadDoc (row) {
      let fileId = row.scmFileCode
      let fileName = row.scmFileName
      let token = util.token.getToken()
      window.location.href = '/oss/ossDowloadLocal?fileID=' + fileId + '&fileName=' + fileName + '&token=' + '"' + token + '"'
    },
    del (row) {
      this.$confirm('确定要删除“' + row.scmFileName + '”吗？', '提示').then(() => {
        this.$api.scmInfoDocUpdateApi({ scmCode: row.scmCode, seqno: row.seqno, scmFileStatus: 'N' }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功 '
          })
          this.getData()
        })
      })
        .catch(() => {
        })
    },
    back () {
      this.dialogVisible1 = false
    },
    sizeChange (val) {
      this.params.curPage = 1
      this.params.pageSize = val
      this.getData()
    },
    currentChange (val) {
      this.params.curPage = val
      this.getData()
    }
  }
}
</script>
